import { ReportTypes } from "@/app/reports/utils/enums";
import httpManager from "@/app/shared/utils/httpManager";

export interface DownloadDto {
  entity: number;
}

class PhonesReport {
  private baseUrl = `/reports/${ReportTypes.Phones}/download`;

  async download(downloadDto: DownloadDto) {
    const { entity } = downloadDto;

    const url = `${this.baseUrl}/?entity=${entity}`;

    const response = await httpManager.post(url, {}, { blob: true });

    return response;
  }
}

export const phonesReportService = new PhonesReport();
